<template>
  <header class="header">
    <PrimaryTitle>
      <slot name="title" />      
    </PrimaryTitle>
    <SecondaryTitle
      v-if="$slots.subtitle"
      class="subtitle"
    >
      <slot name="subtitle" />
    </SecondaryTitle>
  </header>
</template>

<script>
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import SecondaryTitle from '@/components/text/titles/SecondaryTitle'
  import ContentDivisor from '@/components/layout/ContentDivisor'

  export default {
    components: {
      PrimaryTitle,
      SecondaryTitle,
      ContentDivisor,
    },
    props: {
      isContentDivisorVisible: {
        type: Boolean,
        default:true

      }
    },
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .header {
    position: relative;
    text-align: center;
    margin-bottom: 24px;
    padding-left: 1rem;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      background: linear-gradient(158deg, $highlightPrimaryColor 4.86%, $red100 52.82%, $purple200 100.77%);
    }

    .subtitle { 
      margin-top: 4px 
    }
  }
</style>